import { Injectable } from '@angular/core';
import { ApiResourceService } from 'libraries/service/apiResource/apiResource.service';
import { Observable } from 'rxjs';
import { RESOURCE, IOsmanCompany } from './osman';

const CONTEXT: string = 'companies';

@Injectable({ providedIn: 'root' })
export class OsmanCompanyResource {
    constructor(private readonly apiResourceService: ApiResourceService) {}

    public getCompanies(isVendor: boolean = true, isActive: boolean = true): Observable<IOsmanCompany[]> {
        return this.apiResourceService.post(
            this.apiResourceService.getApiUrl(RESOURCE, CONTEXT, 'search'),
            {
                isVendor,
                isActive
            }
        );
    }

    public getCompany(companyCode: string): Observable<IOsmanCompany> {
        return this.apiResourceService.getOne(
            this.apiResourceService.getApiUrl(RESOURCE, CONTEXT, companyCode),
        );
    }
}